/**
 * In-memory token store.
 *
 * The access token is intentionally kept in a module-level variable rather
 * than localStorage/sessionStorage. Module memory is not accessible to
 * injected scripts, eliminating the XSS token-theft vector that plagues
 * localStorage-based JWT storage.
 *
 * The token is lost on a full page refresh; the app restores the session by
 * calling /auth/refresh on bootstrap (see auth store) using the HttpOnly
 * refresh-token cookie. During an active session, the auth store also runs
 * a proactive timer to refresh shortly before expiry.
 */
let _accessToken = null;
let _tenantToken = null;

function _decodeExpiry(token) {
  if (!token) return null;
  try {
    // JWT uses base64url (no padding); atob expects standard base64 with
    // length-mod-4 padding, so pad with '=' before decoding.
    const base64url = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64url + '='.repeat((4 - base64url.length % 4) % 4);
    const decoded = JSON.parse(atob(padded));
    return decoded.exp ? decoded.exp * 1000 : null; // convert to ms
  } catch {
    return null;
  }
}

export const tokenService = {
  getToken: () => _accessToken,
  setToken: (token) => { _accessToken = token; },
  clearToken: () => { _accessToken = null; },
  getTenantToken: () => _tenantToken,
  setTenantToken: (token) => { _tenantToken = token; },
  clearTenantToken: () => { _tenantToken = null; },
  getTokenExpiry: (token) => _decodeExpiry(token),
  isTokenExpiredOrMissing: () => {
    const expiry = _decodeExpiry(_accessToken);
    return expiry === null || Date.now() >= expiry;
  },
};
